var map = {
	"./01_thumbnail.jpg": 546,
	"./02_thumbnail.jpg": 547,
	"./03_thumbnail.jpg": 548,
	"./04_thumbnail.jpg": 549,
	"./07_thumbnail.jpg": 550,
	"./2ATH3BK.crop.jpg": 551,
	"./ABENT3.crop_thumb.jpg": 552,
	"./Around-img-1.jpg": 553,
	"./Around-img-1@2x.jpg": 554,
	"./Crater17-Chuvilin.jpg": 555,
	"./Footer-Desktop.jpg": 556,
	"./Footer-Mobile.jpg": 557,
	"./Footer-Tablet.jpg": 558,
	"./GettyImages-1229380660_thumbnail.jpg": 559,
	"./GettyImages-683364764_crop.jpg": 560,
	"./James-wong-article-thumbnail.jpg": 561,
	"./James-wong-thumbnail.jpg": 562,
	"./LNC-aggregates-on-sand-2-crop.jpg": 563,
	"./Mountain_pines_Uttarakhand_cred_Alamy.jpg": 564,
	"./Opt_out_bell.svg": 565,
	"./Opt_out_message.svg": 566,
	"./Seawatergreenhouseaus_crop.jpg": 567,
	"./The_miller_delivering_flour_to_people_homes.jpg": 568,
	"./Thought-leaders-thumbnail.jpg": 569,
	"./Water_hyacinth_GettyImages-170500069.jpg": 570,
	"./about-icon.png": 571,
	"./add-to-home.png": 572,
	"./add-to-home.svg": 573,
	"./aerial.jpg": 574,
	"./africa_getty.jpg": 575,
	"./arrow_icon.svg": 576,
	"./arrow_right.svg": 577,
	"./bbc-logo.png": 578,
	"./bbc-storyworks-logo.png": 579,
	"./bug.jpg": 580,
	"./cattle-drones-thumbnail.jpg": 581,
	"./cityFarms.jpg": 582,
	"./client-logo-white-02.svg": 583,
	"./client-logo.png": 584,
	"./client-logo.svg": 585,
	"./client-logo2.png": 586,
	"./coffee.jpg": 587,
	"./crops.png": 588,
	"./external_1.jpg": 589,
	"./external_2.jpg": 590,
	"./external_3.jpg": 591,
	"./external_4.jpg": 592,
	"./farmer.jpg": 593,
	"./farming-in-forests-article.jpg": 594,
	"./farms.png": 595,
	"./food-chain-thumbnail-article.jpg": 596,
	"./hero_getty.jpg": 597,
	"./how-covid-19-is-changing-food-shopping.jpg": 598,
	"./how-we-can-adapt-plants-to-save-our-planet-thumbnail.jpg": 599,
	"./how_algae_could_transform_diets_article.jpg": 600,
	"./kiwi-picker-robotics.jpg": 601,
	"./leftArrow.svg": 602,
	"./mineral.png": 603,
	"./miracles_in_a_crisis.jpg": 604,
	"./opt-in-bar.svg": 605,
	"./plastic-problem-article.jpg": 606,
	"./rightArrow.svg": 607,
	"./rooftop.jpg": 608,
	"./save_the_bees_article.jpg": 609,
	"./the-fisherman-selling-his-catch-on-social-media.jpg": 610,
	"./the-freedom-soup-saving-a-city.jpg": 611,
	"./the-green-milk-made-from-cells.jpg": 612,
	"./the-massive-farms-emerging-beneath-our-cities.jpg": 613,
	"./the-simple-shellfish-that-fights-climate-change-thumbnail.jpg": 614,
	"./the-urban-farm-sending-meals-to-children.jpg": 615,
	"./the_invisible_women_article.jpg": 616,
	"./update-bar.svg": 617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;